(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[22492],{

/***/ 35231:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]",
      function () {
        return __webpack_require__(16138);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 16138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var UI_views_Blog__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35745);





var ArticleContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25418), __webpack_require__.e(53809), __webpack_require__.e(30682)]).then(__webpack_require__.bind(__webpack_require__, 30213));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30213)
            ];
        }
    }
});
var Article = function(_param) {
    var tagsList = _param.tagsList, currentPage = _param.currentPage, introSection = _param.introSection, articlesNumberPerPage = _param.articlesNumberPerPage, isArticle = _param.isArticle, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "tagsList",
        "currentPage",
        "introSection",
        "articlesNumberPerPage",
        "isArticle"
    ]);
    return isArticle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArticleContainer, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        introSection: introSection
    }, rest)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_views_Blog__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        tagsList: tagsList,
        articlesNumberPerPage: articlesNumberPerPage,
        currentPage: currentPage,
        introSection: introSection
    }, rest));
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Article);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [25675,24168,74129,18914,55330,39889,57330,13107,15805,72852,47810,49774,92888,40179], function() { return __webpack_exec__(35231); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);